import React from 'react';
import './StatusCellRenderer.scss';
export const AuditStatusCellRenderer = (params: any) => {
    const item = params.data.audit_display_status && params.data.audit_display_status.split('_').join(" ");
    return (
        < >
        <div className='status_column' > {item} </div>
        </ >
    );
}